import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import {
    Autocomplete,
    Button, Dialog, DialogActions, DialogContent, DialogTitle, Menu,
    MenuItem,
    TextField, Grid
} from '@mui/material';
import api from "../../configs/api"
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import dayjs from 'dayjs';
import { Backdrop, CircularProgress } from '@mui/material';
import axios from 'axios';
const ExcelReturnOrder = ({ productTransactions, dataAPIEndPoint, transactionType, selectDate, brands, startDate, endDate, name }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [loading, setLoading] = useState(false);
    const [brandModalOpen, setBrandModalOpen] = useState(false);
    const [selectBrand, setSelectBrand] = useState(null);
    const [startDateBrand, setStartDateBrand] = useState(null);
    const [endDateBrand, setEndDateBrand] = useState(null);
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleOpenBrandModal = () => {
        setAnchorEl(null);
        setBrandModalOpen(true);
    };

    const handleConfirmBrand = () => {
        setBrandModalOpen(false);
        handleExportListAll(selectBrand._id || selectBrand.id);
    };


    const handleExportListAll = async () => {
        setLoading(true); // แสดง loading spinner
        try {
            const payload = {
                startDate: startDate || startDateBrand || '',
                endDate: endDate || endDateBrand || '',
                selectBrand: selectBrand?._id || '',
                // เพิ่มพารามิเตอร์อื่นๆ ที่ต้องการส่งไปกรองข้อมูลใน Backend
                name: name || '',
                selectDate: selectDate || '',
                type: transactionType || '',
            };

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/product-transaction-return/export-all`, // ✅ เรียกใช้ API Backend ที่เราสร้างขึ้น
                payload,
                {
                    responseType: 'blob', // ✅ สำคัญ: บอกให้ Axios รับข้อมูลเป็น Blob (ไฟล์)
                    timeout: 180000 // ตั้งค่า Timeout ให้สูงพอสำหรับการประมวลผลข้อมูลขนาดใหญ่ (3 นาที)
                }
            );

            // สร้าง Blob จากข้อมูลที่ได้กลับมา
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            console.log("blob", blob);


            // สร้างชื่อไฟล์ที่มี timestamp
            const timestamp = dayjs().format('YYYY-MM-DD_HH-mm-ss');
            saveAs(blob, `รายงานรายการรับคืนสินค้า_${timestamp}.xlsx`);

        } catch (error) {
            console.error('❌ Export error:', error);
            alert(`ไม่สามารถดาวน์โหลดไฟล์ Excel ได้: ${error?.message || 'Unknown error'}`);
        } finally {
            setLoading(false); // ซ่อน loading spinner
        }
    };

    return (
        <div>

            <div>
                <Backdrop open={!!loading} style={{ zIndex: 9999, color: '#fff' }}>
                    <CircularProgress color="inherit" />
                    <span style={{ marginLeft: 16 }}>กำลังสร้างไฟล์ Excel...</span>
                </Backdrop>
                <Button
                    variant='contained'
                    color='success'
                    onClick={handleClick}
                    startIcon={<InsertDriveFileOutlinedIcon />}
                    endIcon={<ArrowDropDownIcon />}
                >
                    <div className='text-white'>ดาวน์โหลดข้อมูลรับคืนสินค้า</div>
                </Button>

                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    <MenuItem onClick={handleExportListAll}>✅ ดาวน์โหลดที่เลือก</MenuItem>
                    <MenuItem onClick={handleOpenBrandModal}>📥 ดาวน์โหลดตามแบรนด์</MenuItem>
                </Menu>
                <Dialog
                    open={brandModalOpen}
                    onClose={() => setBrandModalOpen(false)}
                    maxWidth="xs"
                    fullWidth
                    PaperProps={{
                        style: {
                            background: '#fff',
                            borderRadius: 12,
                        }
                    }}
                >
                    <DialogTitle sx={{ fontSize: 24, textAlign: 'center', mt: 2 }}>กรองตามแบรนด์</DialogTitle>
                    <DialogContent sx={{ width: '100%', maxWidth: 500 }}>
                        <Grid item xs={12} md={2.5}>
                            <div className=' pt-2'>
                                <TextField
                                    label="วันที่เริ่มต้น"
                                    type="date"
                                    fullWidth
                                    size="small"
                                    value={startDateBrand}
                                    onChange={(e) => {
                                        setStartDateBrand(e.target.value);
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />

                            </div>

                        </Grid>
                        <Grid item xs={12} md={2.5}>
                            <div className=' pt-2'>
                                <TextField
                                    label="วันที่สิ้นสุด"
                                    type="date"
                                    fullWidth
                                    size="small"
                                    value={endDateBrand}
                                    onChange={(e) => {
                                        setEndDateBrand(e.target.value);
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </div>
                        </Grid>
                        <Autocomplete
                            fullWidth
                            options={brands}
                            getOptionLabel={(option) => option.name}
                            value={selectBrand}
                            onChange={(event, newValue) => {
                                setSelectBrand(newValue);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="แบรนด์"
                                    variant="outlined"
                                    placeholder="พิมพ์เพื่อค้นหาแบรนด์..."
                                    sx={{ mt: 2 }}
                                />
                            )}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id || option._id}>
                                    {option.name}
                                </li>
                            )}
                            isOptionEqualToValue={(option, value) =>
                                (option.id || option._id) === (value?.id || value?._id)
                            }
                            noOptionsText="ไม่พบแบรนด์ที่ค้นหา"
                            filterOptions={(options, { inputValue }) =>
                                options.filter(option =>
                                    option.name.toLowerCase().includes(inputValue.toLowerCase())
                                )
                            }
                        />
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
                        <Button onClick={() => setBrandModalOpen(false)}>ยกเลิก</Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleConfirmBrand}
                            disabled={!selectBrand}
                        >
                            ตกลง
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div >

    );
};


export default ExcelReturnOrder;
